export default {"src":"/_next/static/media/nuls.806163ea.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};